import { render, staticRenderFns } from "./customerFanliTable.vue?vue&type=template&id=7b72d4bd"
import script from "./customerFanliTable.vue?vue&type=script&lang=js"
export * from "./customerFanliTable.vue?vue&type=script&lang=js"
import style0 from "./customerFanliTable.vue?vue&type=style&index=0&id=7b72d4bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports